import {
  Component,
  Directive,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit
} from '@angular/core';
import {
  HeatmapComboboxComponent
} from "@app/netscope/netscope-heatmap-viewer/heatmap-combobox/heatmap-combobox.component";
import {
  of
} from "rxjs";
import {
  NetscopeResource,
  ResourceWithSide,
  SharedFilterOptions
} from "@app/netscope/netscope-flows-datagrid/netscope-flows-datagrid.component";
import {FlowDetail} from "@app/netscope/model/data-models";
import {FlowsRepository} from "@app/netscope/model/flows-repository";


class ValueItem {
  key: string | number;
  label: string;
}

@Component({
    standalone: false,
  selector: 'discrete-values-filter',
  templateUrl: './discrete-values-filter.component.html',
  styleUrls: ['./discrete-values-filter.component.css']
})
export class DiscreteValuesFilterComponent implements OnInit {

  options;

  atLeastOneItemIsNotSelectionned = false;

  @Input()
  flowsRepository: FlowsRepository;

  @Input()
  label;

  @Input()
  selectorToObject: (FlowDetail) => Object;

  @Input()
  selectorToList: (FlowDetail) => Object[];

  @Input()
  isListProperty = false

  @Input()
  items: any[];

  @Input()
  column: string;

  @Input()
  sharedOptions: SharedFilterOptions = new SharedFilterOptions();

  @Input()
  tableUpdate: EventEmitter<any>;

  valueItems: ValueItem[] = [];

  changes: any = new EventEmitter<any>(false);

  manualRefresh: EventEmitter<void> = new EventEmitter<void>();

  filteredValues = {};
  _wantedValues: string[] = [];

  ngOnInit() {
    this.initFilter();

    // If table config is not dynamic, there is no need to provide an event emitter
    if (this.tableUpdate != undefined) {
      this.tableUpdate.subscribe(items => {
        this.items = items;
        this.initFilter();
        this.manualRefresh.emit();
      });
    }
  }

  initFilter = async () => {
    let items = await this.flowsRepository.getAllDiscreteValues([this.column]);

    let values: ValueItem[] = [];
    if (this.column.includes("country")) {
      values = items
        .map((i) => this.flowsRepository.countryMap.get(i[this.column]))
        .filter((i) => i != null)
        .map((i) => ({
            key: i.countryCode,
            label: i.country,
          })
        );
    }
    if (this.column.includes("asn")) {
      values = items
        .map((i) => this.flowsRepository.asnMap.get(i[this.column]))
        .filter((i) => i != null)
        .map((i) => ({
            key: i.asnNum,
            label: i.asn
          })
        );
    }

    for (let value of values) {
        this.filteredValues[value.key] = true;
    }

    this.updateWantedValues();

    let uniqueValues = new Array(...values);
    let sortedUniqueValues = uniqueValues.sort();

    this.valueItems.splice(0);
    this.valueItems.push(...sortedUniqueValues);

    this.triggerEvent();
  }

  updateWantedValues() {
    // Update wanted values
    let items = Object.entries(this.filteredValues);
    this._wantedValues = items
      .filter(([k, v]) => v === true)
      .map(([k, v]) => k);
  }

  triggerEvent() {
    this.updateWantedValues();
    this.changes.emit(true);
  }

  accepts(flowDetail: FlowDetail) {
    let values = [];

    if (this.selectorToObject !== undefined) {
      values = [this.selectorToObject(flowDetail)];
    }

    if (this.selectorToList !== undefined) {
      values = this.selectorToList(flowDetail);
    }

    for (let selectedItem of this._wantedValues) {
      if (values.indexOf(selectedItem) !== -1) {
        return true;
      }
    }

    return false;
  }

  resourceSelectionChanged = (event) => {

    let keyIsString = true;
    if (this.column.includes("asn")) {
      keyIsString = false;
    }

    // Set the column filter in the flow Repository
    let individualExpressions = this
      .valueItems.filter((v) => ! this.filteredValues[v.key])
      .map((v) => keyIsString ? ` '${v.key}' ` : ` ${v.key}`)
      .map((k) => `${this.column} = ${k}`);


    let expression = " FALSE ";
    if (individualExpressions.length > 0) {
      expression = individualExpressions.join(" OR ");
    }
    let columnFilter = ` NOT (${expression}) `

    this.flowsRepository.datagridFilterMap.set(this.column, columnFilter);

    this.atLeastOneItemIsNotSelectionned = individualExpressions.length > 0;

    this.triggerEvent();
  }

  isActive(): boolean {
    return this.atLeastOneItemIsNotSelectionned;
  }

  checkAll() {
    for (let value of this.valueItems) {
      this.filteredValues[value.key] = true;
    }
    this.resourceSelectionChanged(undefined);
  }

  uncheckAll() {
    for (let value of this.valueItems) {
      this.filteredValues[value.key] = false;
    }
    this.resourceSelectionChanged(undefined);
  }
}

